export default {
  privacy: 'Privacy Policy',
  terms: 'Terms & Conditions',
  select: 'View All Reports'
};
